// „Блокчетата" на схемата: елементът се рисува отгоре, а под него се вижда
// страната му (дебелината) и мека сянка върху пода — както в макета на
// началния екран на „Резервации", но без перспектива. И двете падат право
// надолу по ЕКРАНА, както и да е завъртян елементът, затова се смятат тук и
// отиват в inline `box-shadow` (изключение (1) от правило 3).

/**
 * Блокчетата: дебелината в пиксели на дизайна (× `designPixel` на екрана) и
 * цветът на страната — токенът на контура на елемента (`schema-*-edge`).
 */
export const BLOCKS = {
  table: { depth: 5, side: "var(--color-schema-table-edge)" },
  chair: { depth: 1.5, side: "var(--color-schema-chair-edge)" },
  bar: { depth: 8, side: "var(--color-schema-bar-edge)" },
  stage: { depth: 4, side: "var(--color-schema-stage-edge)" },
  dj: { depth: 6, side: "var(--color-schema-dj-edge)" },
  plant: { depth: 3, side: "var(--color-schema-plant-edge)" },
  wall: { depth: 4, side: "var(--color-schema-wall-depth)" },
} as const;

// Под толкова пиксела страната се слива с контура и блокчето изглежда плоско.
const MIN_DEPTH_PX = 1.5;
// Сянката върху пода: колко по-далеч от страната пада и колко е размита.
const FLOOR_SHADOW_REACH = 2.2;
const FLOOR_SHADOW_BLUR = 2.6;
const FLOOR_SHADOW_COLOR = "rgba(28,25,23,0.13)";

const pixels = (value: number) => `${Math.round(value * 100) / 100}px`;

/** Дебелината на екрана: `designDepth` пиксела от дизайна при `designPixel` екранни за един. */
export const blockDepthPx = (designDepth: number, designPixel: number) =>
  Math.max(MIN_DEPTH_PX, designDepth * designPixel);

/**
 * `box-shadow` на блокче: `ring` (ореол/избор, ако има), страната в цвят
 * `color` и сянката върху пода. `rotation` е завъртането на елемента в
 * градуси (CSS, по часовника) — отместването се обръща обратно, за да сочи
 * надолу по екрана. `floorShadow: false` — само страната (столовете).
 * `depth: 0` — плоско (само `ring`).
 */
export const blockShadow = ({
  rotation,
  depth,
  color,
  ring = null,
  floorShadow = true,
}: {
  rotation: number;
  depth: number;
  color: string;
  ring?: string | null;
  floorShadow?: boolean;
}) => {
  const radians = (rotation * Math.PI) / 180;
  const downX = Math.sin(radians);
  const downY = Math.cos(radians);
  const offset = (length: number) => `${pixels(downX * length)} ${pixels(downY * length)}`;
  const layers = [
    ring,
    depth > 0 ? `${offset(depth)} 0 0 ${color}` : null,
    depth > 0 && floorShadow
      ? `${offset(depth * FLOOR_SHADOW_REACH)} ${pixels(depth * FLOOR_SHADOW_BLUR)} ${FLOOR_SHADOW_COLOR}`
      : null,
  ].filter(Boolean);
  return layers.length > 0 ? layers.join(", ") : undefined;
};
